import React from 'react'
import '../stylesheets/popups.sass'
import mail from '../img/Mail.png'
import instagram from '../img/Instagram.png'
import Content from '../StaticContent.json'

class InstagramPopup extends React.Component {
	
	constructor (props) {
		super(props)
		this.state = {manual: false, language: props.language}
		this.close = props.close
	}
	render () {

		let content = this.state.language === "de" ? Content.de.instagrampopup : Content.en.instagrampopup

		if (!this.state.manual){
			return (<div className="popup dark">
						<div className="background" onClick={() => {this.close("instagram")}}></div>
						<div className="foreground">
							<img src={instagram} alt="Instagram Icon"/>
							<div>
							<h2>{content[0]}</h2>
							<div className="manual"><h3>{content[1]}</h3><h3 className="link" onClick={() => {this.setState({manual: true})}}>{content[2]}</h3></div>
							</div>
							<h1 onClick={() => {this.close("instagram")}}>{content[3]}</h1>
						</div>
					</div>)
	}

	content = this.state.language === "de" ? Content.de.manualinstagrampopup : Content.en.manualinstagrampopup

	return (<div className="popup dark">
						<div className="background" onClick={() => {this.close("instagram")}}></div>
						<div className="foreground">
							<img src={instagram} alt="Instagram Icon"/>
							<div>
							<h2>{content[0]}</h2>
							<h3>{content[1]}</h3>
							</div>
							<h1 onClick={() => {this.close("instagram")}}>{content[2]}</h1>
						</div>
					</div>)
	}
}
class MailPopup extends React.Component {
	constructor (props) {
		super(props)
		this.state = {manual: false, language: props.language}
		this.close = props.close
	}
	render () {

		let content = this.state.language === "de" ? Content.de.mailpopup : Content.en.mailpopup

		if (!this.state.manual){
			return (<div className="popup light">
						<div className="background" onClick={() => {this.close("mail")}}></div>
						<div className="foreground">
							<img src={mail} alt="Mail Icon"/>
							<div>
							<h2>{content[0]}</h2>
							<div className="manual"><h3>{content[1]}</h3><h3 className="link" onClick={() => {this.setState({manual: true})}}>{content[2]}</h3></div>
							</div>
							<h1 onClick={() => {this.close("mail")}}>{content[3]}</h1>
						</div>
					</div>)
	}

		content = this.state.language === "de" ? Content.de.manualmailpopup : Content.en.manualmailpopup

		return (<div className="popup light">
							<div className="background" onClick={() => {this.close("mail")}}></div>
							<div className="foreground">
								<img src={mail} alt="Mail Icon"/>
								<div>
								<h2>{content[0]}</h2>
								<h3>{content[1]}</h3>
								</div>
								<h1 onClick={() => {this.close("mail")}}>{content[2]}</h1>
							</div>
						</div>)
		}

}


export { InstagramPopup,MailPopup }